import { useEffect, useState } from "react";
import { Grid, Box, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { CustomPieChart } from "../../../../../components/charts";
import { NoDataCard } from "../../../../../components/parts";
import { getData } from "../../../../../services";
import { getPercent } from "../../../../../services/utils";

const useStyles = makeStyles(() => ({
  grid: {
    marginTop: 34,
  },
  text: {
    fontWeight: 700,
    textAlign: "center",
    marginBottom: 30,
  },
  box: {
    height: 260,
  },
}));

export const TenantConnectionStatus = ({ building }) => {
  const classes = useStyles();
  const [totalTenants, setTotalTenants] = useState();
  const [chartData, setChartData] = useState();

  useEffect(() => {
    getData(`/praas/v2/buildings/${building.id}/tenants/tenants-connection/`, (data) => {
      setTotalTenants(data.total_tenants);

      if (data.total_tenants > 0) {
        setChartData([
          {
            name: "Fully Connected",
            value: data?.fully_connected || 0,
            key: "fully_connected",
            centerLabel: "are fully",
            centerSuffixLabel: "connected",
            color: COLORS.green,
            unit: "%",
            value_position: "inline",
            value_percent: data?.fully_connected
              ? getPercent(data?.fully_connected, data.total_tenants)
              : 0,
          },
          {
            name: "Partially Connected",
            value: data?.partially_connected || 0,
            key: "partially_connected",
            centerLabel: "are partially",
            centerSuffixLabel: "connected",
            color: COLORS.purple,
            unit: "%",
            value_position: "inline",
            value_percent: data?.partially_connected
              ? getPercent(data?.partially_connected, data.total_tenants)
              : 0,
          },
          {
            name: "Unconnected",
            value: data?.unconnected || 0,
            key: "unconnected",
            centerLabel: "are",
            centerSuffixLabel: "unconnected",
            color: COLORS.red,
            unit: "%",
            value_position: "inline",
            value_percent: data?.unconnected
              ? getPercent(data?.unconnected, data.total_tenants)
              : 0,
          },
        ]);
      }
    });

    return () => {
      setTotalTenants();
      setChartData();
    };
  }, [building.id]);

  return (
    <ShaDowBox>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">Tenants PRaaS-Connection Status</Typography>
        <Grid container className={classes.grid}>
          <Grid item xs={12}>
            <Typography className={classes.text}>
              Total tenants in this building: {totalTenants}
            </Typography>
            {totalTenants && chartData ? (
              <Box className={classes.box}>
                <CustomPieChart name="ConnectionStatus" data={chartData} />
              </Box>
            ) : (
              <NoDataCard
                withShaDowBox={false}
                boxStyle={{ padding: 0 }}
                gridStyle={{ height: 170 }}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  );
};
